import { NextSeo } from 'next-seo';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const LibrariansResourceSeo: FC = () => {
  const { t } = useTranslation();

  return (
    <NextSeo
      title="Enhance Your Library with Underline Science"
      description={t('librariansResource.seo.description')}
      openGraph={{
        url: `${process.env.NEXT_PUBLIC_BASE_URL}/librarians-resource`,
        title: 'Enhance Your Library with Underline Science',
        images: [
          {
            url: `${process.env.NEXT_PUBLIC_BASE_URL}images/librarians/women-working-laptop.webp`,
            width: 1000,
            height: 667,
            alt: 'Underline.io - Librarians',
          },
        ],
      }}
    />
  );
};
